import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import { useGetMoneyFlow } from "../api/case/document.ts"
import { useCallback, useMemo } from "react"
import { getEdgeId } from "../utils/getEdgeId.ts"
import { useCurrentStep } from "./useCurrentStep.ts"
import { useGetSankeyData } from "../api/sankeyData/get.ts"
import { isEntity } from "../backend/types/entity.ts"

export const useCurrentEntity = () => {
    const navigate = useNavigate()
    const { entityId, documentId, originalId } = useParams()
    const [searchParams] = useSearchParams()
    const { data: moneyflow } = useGetMoneyFlow(documentId, originalId)
    const { currentStep } = useCurrentStep()
    const { data: sankeyData } = useGetSankeyData(moneyflow?.sankeyData[currentStep], !documentId)

    const currentEntity = useMemo(
        () => sankeyData?.Entities.find((entity) => entity.ID === entityId),
        [sankeyData?.Entities, entityId]
    )

    const currentEdge = useMemo(() => sankeyData?.Edges.find(
        (edge) => getEdgeId(edge)  === entityId),
    [sankeyData?.Edges, entityId])

    const setCurrentEntity = useCallback((entityId: string) => {
        navigate(`/moneyflow/${documentId}/${entityId}?${searchParams.toString()}`)
    }, [navigate, documentId, searchParams])

    return {
        currentEntity: currentEntity || currentEdge,
        setCurrentEntity,
        isEntity: isEntity(currentEntity),
        entityAppID: entityId ?? 'origin'
    }
}
